var _path, _path2, _g, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a/icon_link copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58815 4.34081C10.5395 2.38948 13.7082 2.3945 15.6569 4.34315C17.6095 6.29577 17.6074 9.46372 15.6592 11.4119L11.4119 15.6592C9.46056 17.6105 6.29181 17.6055 4.34316 15.6569C2.39054 13.7042 2.39267 10.5363 4.34082 8.58814L8.58815 4.34081ZM10.002 5.75535L5.75536 10.002C4.58473 11.1727 4.5858 13.0711 5.75738 14.2426C6.92657 15.4118 8.82754 15.4151 9.998 14.2447L14.2447 9.99799C15.4153 8.82736 15.4142 6.92894 14.2427 5.75736C13.0735 4.58818 11.1725 4.58489 10.002 5.75535ZM7.8787 5.05026L5.05027 7.87868L6.46448 9.2929L9.29291 6.46447L7.8787 5.05026ZM13.5356 10.7071L10.7071 13.5355L12.1213 14.9498L14.9498 12.1213L13.5356 10.7071ZM10.7136 7.87216C11.1006 7.48524 11.7281 7.48544 12.1213 7.87868C12.5119 8.26921 12.5096 8.90468 12.1279 9.28638L9.28639 12.1278C8.89947 12.5148 8.27194 12.5146 7.8787 12.1213C7.48817 11.7308 7.49048 11.0953 7.87218 10.7136L10.7136 7.87216Z",
    fill: "#3E4056"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58815 4.34081C10.5395 2.38948 13.7082 2.3945 15.6569 4.34315C17.6095 6.29577 17.6074 9.46372 15.6592 11.4119L11.4119 15.6592C9.46056 17.6105 6.29181 17.6055 4.34316 15.6569C2.39054 13.7042 2.39267 10.5363 4.34082 8.58814L8.58815 4.34081ZM10.002 5.75535L5.75536 10.002C4.58473 11.1727 4.5858 13.0711 5.75738 14.2426C6.92657 15.4118 8.82754 15.4151 9.998 14.2447L14.2447 9.99799C15.4153 8.82736 15.4142 6.92894 14.2427 5.75736C13.0735 4.58818 11.1725 4.58489 10.002 5.75535ZM7.8787 5.05026L5.05027 7.87868L6.46448 9.2929L9.29291 6.46447L7.8787 5.05026ZM13.5356 10.7071L10.7071 13.5355L12.1213 14.9498L14.9498 12.1213L13.5356 10.7071ZM10.7136 7.87216C11.1006 7.48524 11.7281 7.48544 12.1213 7.87868C12.5119 8.26921 12.5096 8.90468 12.1279 9.28638L9.28639 12.1278C8.89947 12.5148 8.27194 12.5146 7.8787 12.1213C7.48817 11.7308 7.49048 11.0953 7.87218 10.7136L10.7136 7.87216Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_/color_red copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    fill: "#3E4056"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05028 7.87867C5.44081 7.48815 6.07125 7.48543 6.4645 7.87867C6.85502 8.2692 6.85774 8.89964 6.4645 9.29289C6.07397 9.68341 5.44353 9.68613 5.05028 9.29289C4.65976 8.90236 4.65703 8.27192 5.05028 7.87867ZM10.7071 13.5355C11.0977 13.145 11.7281 13.1423 12.1213 13.5355C12.5119 13.9261 12.5146 14.5565 12.1213 14.9497C11.7308 15.3403 11.1004 15.343 10.7071 14.9497C10.3166 14.5592 10.3139 13.9288 10.7071 13.5355ZM13.5356 10.7071C13.9261 10.3166 14.5565 10.3139 14.9498 10.7071C15.3403 11.0976 15.343 11.7281 14.9498 12.1213C14.5593 12.5118 13.9288 12.5146 13.5356 12.1213C13.145 11.7308 13.1423 11.1003 13.5356 10.7071ZM7.87871 5.05025C8.26923 4.65972 8.89968 4.657 9.29292 5.05025C9.68345 5.44077 9.68617 6.07121 9.29292 6.46446C8.9024 6.85498 8.27196 6.85771 7.87871 6.46446C7.48818 6.07394 7.48546 5.44349 7.87871 5.05025Z",
    fill: "#3E4056"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 12,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05028 7.87867C5.44081 7.48815 6.07125 7.48543 6.4645 7.87867C6.85502 8.2692 6.85774 8.89964 6.4645 9.29289C6.07397 9.68341 5.44353 9.68613 5.05028 9.29289C4.65976 8.90236 4.65703 8.27192 5.05028 7.87867ZM10.7071 13.5355C11.0977 13.145 11.7281 13.1423 12.1213 13.5355C12.5119 13.9261 12.5146 14.5565 12.1213 14.9497C11.7308 15.3403 11.1004 15.343 10.7071 14.9497C10.3166 14.5592 10.3139 13.9288 10.7071 13.5355ZM13.5356 10.7071C13.9261 10.3166 14.5565 10.3139 14.9498 10.7071C15.3403 11.0976 15.343 11.7281 14.9498 12.1213C14.5593 12.5118 13.9288 12.5146 13.5356 12.1213C13.145 11.7308 13.1423 11.1003 13.5356 10.7071ZM7.87871 5.05025C8.26923 4.65972 8.89968 4.657 9.29292 5.05025C9.68345 5.44077 9.68617 6.07121 9.29292 6.46446C8.9024 6.85498 8.27196 6.85771 7.87871 6.46446C7.48818 6.07394 7.48546 5.44349 7.87871 5.05025Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_/color_red copy_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color_2",
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    fill: "#3E4056"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedIcon);
export default __webpack_public_path__ + "static/media/shared-icon.d14a9cbac02159de5d227903fa014612.svg";
export { ForwardRef as ReactComponent };